import React, { useState } from 'react';
import './Subtotal.css';
import CurrencyFormat from 'react-currency-format';
import { useStateValue } from './StateProvider';
import { getBasketTotal } from './reducer';
import { useNavigate } from 'react-router-dom';

function Subtotal() {
  const navigate = useNavigate();
  const [{ basket }, dispatch] = useStateValue();
  const [superFastDelivery, setSuperFastDelivery] = useState(false);
  const deliveryCost = superFastDelivery ? 99 : 0; // Add ₹99 if superFastDelivery is checked

  return (
    <div className="subtotal">
      <CurrencyFormat
        renderText={(value) => (
          <>
            <p>
              Bag Total ({basket.length} items): <strong>{value}</strong>
            </p>
            <small className="subtotal__gift">
              <input
                type="checkbox"
                onChange={() => setSuperFastDelivery(!superFastDelivery)}
              />{' '}
              Add Super Fast Delivery (Worth ₹99)
            </small>
          </>
        )}
        decimalScale={2}
        value={getBasketTotal(basket) + deliveryCost} // Add delivery cost to the total
        displayType={"text"}
        thousandSeparator={true}
        prefix={"₹"}
      />
      <button onClick={e=>navigate('/payment')}>Proceed to Payment</button>
    </div>
  );
}

export default Subtotal;
